import React, { useEffect, useState } from 'react';
import './projetos2.css'
import HomeLf from './HomeLf';
import { db, firebaseAuth } from '../utils/firebase-config';
import { onAuthStateChanged } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { collection, doc, getDocs, updateDoc } from 'firebase/firestore';
import addicon from '../assets/version2/addicon.png';
import circleadd from '../assets/version2/circleadd.png';
import Rodape from './Rodape';
function AdicionarDisciplina(params) {

  const navigate = useNavigate();


  const [current, setCurrent] = useState('');
  const [filtrados, setFiltrados] = useState([]);
  const [mapfake, setMapfake] = useState([1,2,3]);
  const [mapfake2, setMapfake2] = useState([2]);


    const [countMp, setCountMp] = useState(1);
    const [mapeA, setMapeA] = useState([1]);
    const [dataA, setDataA] = useState([]);


    var trad = [];




var count01 = 0;


async function master(params) {

      var disciplinas = [];
      for (let index = 0; index < document.querySelectorAll('.dadosinput').length; index++) {
        disciplinas.push(document.querySelectorAll('.dadosinput')[index].value)
        
      }
   
    await fetch('https://apilumera.shop/api/adicionardisciplina', {
        method: 'POST',
        body: JSON.stringify({
            disciplinas: disciplinas,
            email: firebaseAuth.currentUser.email
    
        }),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      })
         .then((response) => response.json())
         .then((data) => {
              navigate('/adicionarcolaboradores')
  
    
         })
         .catch((err) => {
            navigate('/adicionarcolaboradores')

         });

}

var mmm = 0;

function mapear() {
            
  setCountMp(countMp + 1);

  for (let i = 0; i < countMp; i++) {
      trad.push(i);
      
  }
  trad.push(countMp);
  console.log(trad);
  setMapeA(trad);
}









    return (
        <div>


<HomeLf/>

<div className="fixmargin"></div>

<div className="row" style={{ marginTop: 50, padding: "0px 60px" }}>
  <div className="col-3 hideconfig" style={{ flexFlow: "column" }}>
    <div
      style={{
        border: "1px #DEE1E6 solid",
        borderRadius: 10,
        padding: "25px 14px",
        height: "85vh"
      }}
    >
      <div
        style={{
          marginBottom: 12,
          display: "flex",
          justifyContent: "space-between"
        }}
      >
        <a
          style={{
            fontFamily: "Archivo, serif",
            fontWeight: "bold",
            fontSize: 16
          }}
        >
          Configurações do projeto
        </a>
        <i className="bi bi-caret-down-fill" />
      </div>
      <div
        style={{
          height: 40,
          backgroundColor: "#F3F4F6",
          borderRadius: 16,
          display: "flex",
          alignItems: "center"
        }}
      >
        <img
          src={addicon}
          style={{ width: 24, height: 24, marginLeft: 17, marginRight: 7 }}
        />
        <a
          style={{
            fontFamily: "Inter, serif",
            fontWeight: "bold",
            fontSize: 14,
            color: "#565D6D"
          }}
        >
          Disciplina{" "}
        </a>
      </div>
      <div
        style={{
          width: 240,
          height: 40,
          borderRadius: 16,
          display: "flex",
          alignItems: "center",
          marginTop: 5
        }}
      >
        <img
          src={circleadd}
          style={{ width: 24, height: 24, marginLeft: 17, marginRight: 7 }}
        />
        <a
          style={{ fontFamily: "Inter, serif", fontSize: 14, color: "#565D6D", cursor: 'pointer' }}
            onClick={()=> navigate('/adicionarcolaboradores')}
        >
          Colaboradores{" "}
        </a>
      </div>
    </div>
  </div>
  <div className="col-9">
    <div style={{ width: "40vw" }}>
      <h2
        style={{
          fontFamily: "Archivo, serif",
          fontSize: 32,
          fontWeight: "bold",
          color: "#171A1F"
        }}
      >
        Disciplinas
      </h2>
      <div style={{marginBottom: '30px'}}>
      <a style={{ fontFamily: "Inter, serif", fontSize: 14, color: "#000" }}>
        Adicione as disciplinas que participarão dos projetos no Lumera 3D.
      </a>
      </div>


        {mapeA.map((index, data) => {
          return <>
          
          <div
        style={{
          border: "1px solid #BDC1CA",
          borderRadius: 6,
          height: 44,
          display: "flex",
          alignItems: "center",
          marginTop: 10
        }}
      >



        <input
          style={{ border: "none", width: "100%", paddingLeft: 10 }}
          className="inputsemborda dadosinput"
          placeholder="Preencha com o nome da disciplina"
        />
        <i
          className="bi bi-pencil-fill"
          style={{ marginRight: 10, color: "#9095A1" }}
        />
      </div>
          </>

        })}


      
    
      <div style={{ marginTop: 10 }}>
        <a>
          <i className="bi bi-plus" style={{ color: "black", fontSize: 18 }} />
        </a>
        <a
          style={{ color: "#574A69", fontFamily: "Inter, serif", fontSize: 14, cursor: 'pointer' }}
          onClick={()=> mapear()}
        >
          Adicionar Disciplina{" "}
        </a>
      </div>
            <div style={{display: 'flex'}}>
      <div style={{ marginTop: 30 }}>
        <a>
       
        </a>
        <a
          style={{ color: "white", fontFamily: "Inter, serif", fontSize: 14, backgroundColor: 'rgb(159, 109, 175)', padding: '8px 15px',
            borderRadius: '10px', cursor: 'pointer'

           }}
          onClick={()=> master()}
        >
          Salvar{" "}
        </a>
      </div>
  
    <div style={{ marginTop: 30, marginLeft: '10px' }} className='hideconfig2'>
        <a>
       
        </a>
        <a
          style={{ color: "black", fontFamily: "Inter, serif", fontSize: 14, backgroundColor: 'rgb(245, 245, 245)', padding: '8px 15px',
            borderRadius: '10px', cursor: 'pointer'

           }}
          onClick={()=> navigate('/adicionarcolaboradores')}
        >
          Colaboradores{" "}
        </a>
      </div>
</div>
    </div>
  </div>
</div>


<Rodape/>


        </div>
    )
}
export default AdicionarDisciplina;